<!--
 * @Author: wzh
 * @Date: 2022-10-31 10:41:43
 * @LastEditTime: 2023-06-02 14:34:25
 * @Description: 个人资料
-->
<template>
  <div>
    <!-- 基本信息 -->
    <Head :title="$t('home.personal_data.title')" :iconUrl="require('@/assets/images/personal/base_icon.png')" />
    <div class="content">
      <!-- 头像 -->
      <div class="form">
        <a-form-model :model="form" :label-col="labelCol" :wrapper-col="{ span: 18 }">
          <div class="col-box">
            <div class="col-row">
              <a-form-model-item label=" " prop="pictureBase64" class="qu-maohao">
                <div class="tou-x">
                  <UploadImage
                    :isTou="true"
                    :imageUrl="form.pictureBase64"
                    @changeImageUrl="(val) => (form.pictureId = val)"
                    @tranBase64="(val) => (form.pictureBase64 = val)"
                  ></UploadImage>
                  <div class="image-desc">{{ $t("home.personal_data.head_picture_tip") }}</div>
                </div>
              </a-form-model-item>
            </div>
          </div>
        </a-form-model>
      </div>

      <div class="form">
        <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <!-- div默认展示的行数 -->
          <div class="col-box">
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.username')" prop="username">
                <a-input v-model="form.username" disabled />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.sex')" prop="gender">
                <a-radio-group v-model="form.gender">
                  <a-radio :value="0">{{ $t("home.personal_data.sex_man") }}</a-radio>
                  <a-radio :value="1">{{ $t("home.personal_data.sex_woman") }}</a-radio>
                </a-radio-group>
              </a-form-model-item>
            </div>
          </div>

          <!-- 影藏的行数 -->
          <div class="col-box" v-show="showAll">
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.name')" prop="displayName">
                <a-input v-model="form.displayName" disabled />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.birth')" prop="birthDate">
                <a-date-picker v-model="form.birthDate" valueFormat="YYYY-MM-DD" style="width: 100%" />
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.mobile')" prop="mobile">
                <a-input v-model="form.mobile" disabled />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.email')" prop="email">
                <a-input v-model="form.email" disabled />
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.id_type')" prop="idType">
                <a-select v-model="form.idType" disabled>
                  <a-select-option :value="1">{{ $t("base.idCard") }}</a-select-option>
                  <a-select-option :value="2">{{ $t("base.passport") }}</a-select-option>
                  <a-select-option :value="3">{{ $t("base.gatCard") }}</a-select-option>
                  <a-select-option :value="4">{{ $t("base.other") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.id_card_no')" prop="idCardNo">
                <a-input v-model="form.idCardNo" disabled />
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.org')" prop="organization">
                <a-input v-model="form.organizationName" disabled />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.user_type')" prop="userType">
                <a-input v-model="form.userType_dictText" disabled></a-input>
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.qq')" prop="qq">
                <a-input v-model="form.qq" />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.address')" prop="locale">
                <a-input v-model="form.locale" />
              </a-form-model-item>
            </div>

            <!-- author: wzh, date: 2023-06-02, for: 元数据参数 -->
            <div class="col-row" v-for="item in metaDataList" :key="item.attrname">
              <a-form-model-item :key="item.attrname" :prop="`dataMap[${item.attrname}]`">
                <span slot="label">
                  {{ item.showname
                  }}<template v-if="item.attrdesc"
                    >&nbsp;<a-tooltip :title="item.attrdesc"><a-icon type="question-circle-o"/></a-tooltip
                  ></template>
                </span>
                <a-input
                  v-model="form.dataMap[item.attrname]"
                  :placeholder="$t('placeholder.input')"
                  disabled
                ></a-input>
              </a-form-model-item>
            </div>
            <!-- author: wzh, date: 2023-06-02, for: 元数据参数 -->
          </div>
        </a-form-model>
      </div>
    </div>

    <div class="more">
      <div @click="foldShow">{{ showAll ? $t("home.personal_data.fold_up") : $t("home.personal_data.fold_down") }}</div>
    </div>
    <div class="he-line"></div>

    <!-- 账号信息 -->
    <Head
      :title="$t('home.personal_data.title_user')"
      :iconUrl="require('@/assets/images/personal/personal_icon.png')"
    />
    <div class="content">
      <div class="form">
        <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
          <div class="col-box">
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.status')" prop="status">
                <a-select v-model="form.status" disabled>
                  <a-select-option :value="0">{{ $t("home.personal_data.status_common") }}</a-select-option>
                  <a-select-option :value="1">{{ $t("home.personal_data.status_lock") }}</a-select-option>
                  <a-select-option :value="2">{{ $t("home.personal_data.status_file") }}</a-select-option>
                  <a-select-option :value="3">{{ $t("home.personal_data.status_dormant") }}</a-select-option>
                  <a-select-option :value="4">{{ $t("home.personal_data.status_freeze") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.user_state')" prop="userState">
                <a-select v-model="form.userState" disabled>
                  <a-select-option value="1">{{ $t("home.personal_data.state_activate") }}</a-select-option>
                  <a-select-option value="0">{{ $t("home.personal_data.state_inactive") }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.password_strength')">
                <a-input
                  :value="
                    `${
                      form.passlevel
                        ? [
                            $t('base.password.strength_weak'),
                            $t('base.password.strength_medium'),
                            $t('base.password.strength_strong'),
                          ][form.passlevel - 1]
                        : ''
                    }`
                  "
                  disabled
                />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.activate_time')" prop="livedate">
                <a-date-picker
                  v-model="form.livedate"
                  mode="date"
                  valueFormat="YYYY-MM-DD"
                  style="width: 100%"
                  disabled
                />
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.user_life')" prop="liveweek">
                <a-input v-model="form.liveweek" disabled />
              </a-form-model-item>
            </div>
            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.user_life_end')" prop="liveEndDate">
                <a-date-picker
                  v-model="form.liveEndDate"
                  mode="date"
                  valueFormat="YYYY-MM-DD"
                  style="width: 100%"
                  disabled
                />
              </a-form-model-item>
            </div>

            <div class="col-row">
              <a-form-model-item :label="$t('home.personal_data.alias')" prop="alias">
                <a-input v-model="form.alias" disabled />
              </a-form-model-item>
            </div>
          </div>
        </a-form-model>
      </div>
    </div>

    <!-- 学籍信息 学生展示 -->
    <template v-if="form.userIdentity == 1">
      <div class="he-line"></div>
      <Head
        :title="$t('home.personal_data.title_student_status')"
        :iconUrl="require('@/assets/images/personal/personal_icon.png')"
      />

      <div class="content">
        <div class="form">
          <a-form-model :model="form" :label-col="labelCol" :wrapper-col="wrapperCol">
            <div class="col-box">
              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.school')">
                  <a-input v-model="form.school" disabled />
                </a-form-model-item>
              </div>
              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.college')">
                  <a-input v-model="form.college" disabled />
                </a-form-model-item>
              </div>

              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.major')">
                  <a-input v-model="form.career" disabled />
                </a-form-model-item>
              </div>
              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.grade')">
                  <a-input v-model="form.grade" disabled />
                </a-form-model-item>
              </div>

              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.class')">
                  <a-input v-model="form.userclass" disabled />
                </a-form-model-item>
              </div>
              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.school_status')">
                  <a-input v-model="form.xjstatus" disabled />
                </a-form-model-item>
              </div>

              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.entry_year')">
                  <a-date-picker
                    v-model="form.year"
                    mode="year"
                    style="width: 100%"
                    valueFormat="YYYY"
                    format="YYYY"
                    :open="yearShowOne"
                    disabled
                  />
                </a-form-model-item>
              </div>
              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.graduate_time')">
                  <a-date-picker
                    v-model="form.grate"
                    mode="date"
                    valueFormat="YYYY-MM-DD"
                    style="width: 100%"
                    disabled
                  />
                </a-form-model-item>
              </div>

              <div class="col-row">
                <a-form-model-item :label="$t('home.personal_data.offer_card_no')">
                  <a-input v-model="form.admissionNotice" disabled />
                </a-form-model-item>
              </div>
            </div>
          </a-form-model>
        </div>
      </div>
    </template>

    <!-- 提交 -->
    <div class="submit">
      <a-button style="width: 25%" type="primary" @click="submit">{{ $t("base.btn.submit") }}</a-button>
    </div>
  </div>
</template>

<script>
import Head from "../compontents/Head";
import { UploadImage } from "@/components/public/ulpoad";
import { commonAPI } from "@/apis";
export default {
  name: "personal",
  components: { Head, UploadImage },
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
      form: {},
      rules: {},
      showAll: true,
      yearShowOne: false,
      metaDataList: [], // 元数据参数列表
    };
  },
  created() {
    this.getMetaData();
    this.getList();
  },
  methods: {
    // 折叠
    foldShow() {
      this.showAll = !this.showAll;
    },
    // 得到个人基本信息
    async getList() {
      const { code, data } = await commonAPI.getAction("/config/profile/get");
      if (code == 0) {
        this.form = data || {};
      }
    },
    // 提交用户信息
    async submit() {
      const { code, message } = await commonAPI.postAction("/config/profile/update", this.form);
      if (code === 0) {
        this.$message.success(message || this.$t("home.personal_data.success_tip"));
        this.getList();
      } else {
        this.$message.error(message);
      }
    },

    // author: wzh, date: 2023-06-02, for: 获取元数据参数
    async getMetaData() {
      const { code, data } = await commonAPI.getAction("/account/metadata/listToServer");
      if (code == 0) {
        this.metaDataList = data || [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.content {
  padding: 0 30px;
}
.tou-x {
  display: flex;
  align-items: center;
  margin-top: 20px;
  .image-desc {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
    & > p {
      color: #333;
      font-size: 16px;
    }
  }
  ::v-deep .ant-upload.ant-upload-select-picture-card {
    width: 150px;
    height: 150px;
  }
}
.col-box {
  display: flex;
  flex-wrap: wrap;
  .col-row {
    width: 50%;
  }
}
.form {
  margin-top: 20px;
}
.he-line {
  border: 2px solid #f0f2f5;
  margin: 0 -33px 30px;
}
.submit {
  margin-top: 20px;
  text-align: center;
}
.more {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
  & > div {
    text-align: center;
    width: 80px;
    background: #f5f5f5;
    border-radius: 4px;
    cursor: pointer;
    color: #666666;
    font-size: 12px;
    padding: 5px 0;
  }
}
.qu-maohao {
  ::v-deep label {
    display: none;
  }
}
</style>
